import { Outlet } from 'react-router-dom';
import { TopBar } from './TopBar';
import { SideNav } from './SideNav';
import { TabStrip } from './TabStrip';
import { SubscriptionBanner } from '../ui/SubscriptionBanner';

/**
 * Persistent workspace shell: dark top bar + left nav rail + diagram tab strip,
 * hosting the non-editor pages via <Outlet />. The editor renders outside this shell.
 */
export function WorkspaceShell() {
  return (
    <div className="flex h-screen w-full flex-col gap-2 overflow-hidden bg-[var(--topbar)] p-2">
      <TopBar />
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-xl border border-border bg-background shadow-sm">
        <TabStrip />
        <div className="flex min-h-0 flex-1">
          {/* Sidebar is hidden on small screens; navigation stays reachable via ⌘K. */}
          <div className="hidden flex-none p-2 md:block">
            <SideNav />
          </div>
          <main className="min-h-0 min-w-0 flex-1 overflow-y-auto">
            <SubscriptionBanner />
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
